import * as React from 'react';
import classnames from 'classnames';
import { withStyles, WithStyles } from '@material-ui/core';

import { isAnyMobile } from '@lib/services/navigatorService';

import styles from './ExtendedSchedulerContainer.styles';

const isMobile = isAnyMobile();

interface IExtendedSchedulerContainer extends WithStyles<typeof styles> {}

const ExtendedSchedulerContainer: React.FunctionComponent<IExtendedSchedulerContainer> = (props) => {
  const { children, classes } = props;

  return (
    <div className={classnames(classes.showMoreWrapper, { [classes.showMoreWrapperDesktop]: !isMobile })}>
      <div className={classes.showMore}>{children}</div>
    </div>
  );
};

export default withStyles(styles)(ExtendedSchedulerContainer);
